// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lbm-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.lbm-table {
  overflow-x: auto;
}

.lbm-table--narrow {
  max-width: 520px;
}

.lbm-range {
  font-size: 12px;
  color: var(--text-secondary, #666);
}

.lbm-block {
  min-width: 180px;
  font-weight: 600;
}

.lbm-block__order {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  margin-right: 8px;
  border-radius: 50%;
  font-size: 12px;
  background: var(--surface-muted, #eef1f4);
}

.lbm-cell {
  min-width: 200px;
  vertical-align: top;
}

.lbm-cell--work {
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 9%, transparent);
}

.lbm-cell--intro {
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 4%, transparent);
  box-shadow: inset 3px 0 0 color-mix(in srgb, var(--brand-primary, #0877bc) 45%, transparent);
}

.lbm-cell--locked {
  background: var(--surface-muted, #f4f5f7);
}

.lbm-cell__line {
  display: flex;
  gap: 6px;
}

.lbm-cell__roles {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 6px;
}

.lbm-cell__prereq {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
  font-size: 12px;
  color: var(--text-secondary, #666);
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/LevelBandMatrix.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,6EAA6E;AAC/E;;AAEA;EACE,6EAA6E;EAC7E,4FAA4F;AAC9F;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,kCAAkC;AACpC","sourcesContent":[".lbm-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.lbm-table {\n  overflow-x: auto;\n}\n\n.lbm-table--narrow {\n  max-width: 520px;\n}\n\n.lbm-range {\n  font-size: 12px;\n  color: var(--text-secondary, #666);\n}\n\n.lbm-block {\n  min-width: 180px;\n  font-weight: 600;\n}\n\n.lbm-block__order {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  margin-right: 8px;\n  border-radius: 50%;\n  font-size: 12px;\n  background: var(--surface-muted, #eef1f4);\n}\n\n.lbm-cell {\n  min-width: 200px;\n  vertical-align: top;\n}\n\n.lbm-cell--work {\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 9%, transparent);\n}\n\n.lbm-cell--intro {\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 4%, transparent);\n  box-shadow: inset 3px 0 0 color-mix(in srgb, var(--brand-primary, #0877bc) 45%, transparent);\n}\n\n.lbm-cell--locked {\n  background: var(--surface-muted, #f4f5f7);\n}\n\n.lbm-cell__line {\n  display: flex;\n  gap: 6px;\n}\n\n.lbm-cell__roles {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin-top: 6px;\n}\n\n.lbm-cell__prereq {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 6px;\n  font-size: 12px;\n  color: var(--text-secondary, #666);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
